import React, { Component } from 'react';
import { TextField } from 'office-ui-fabric-react';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

export default class TextInput extends Component {
  render() {
    const isEdge = window.navigator.userAgent.includes('Edg') ? true : false;
    let {
      id = '',
      inputValue = '',
      onChange = () => {
        console.log('Function Called');
      },
      isClearIcon = true,
      iconClick = () => {
        console.log('Function Called');
      },
      isError = false,
      errorMessage = '',
      onBlur = () => {
        console.log('Function Called');
      },
      isDisabled = false,
      helperText = '',
      placeholder = '',
      isSetupScreen = false,
      className = '',
    } = this.props;

    let isDisabledStyle = isDisabled
    ? '1px solid #2b2d2e'
    : '';
    let borderStyles = isSetupScreen
      ? '1px solid #A5A6A8'
      : isDisabledStyle;

    let isDisabledBackgroundColorStyle = isDisabled
    ? '#2b2d2e'
    : '#373b3d';
    let backgroundColorStyles = isSetupScreen
      ? 'transparent'
      : isDisabledBackgroundColorStyle;
      
    let showClearIcon = isClearIcon && inputValue ? true : false;

    return (
      <div className="textfield-block">
        <div className="textfield-wrapper">
          <TextField
            id={id}
            className={`textfield-style ${className}`}
            style={{
              border: isError ? '1px solid #DF4661' : borderStyles,
              backgroundColor: this.getBackgroundColor(isSetupScreen, isError, backgroundColorStyles),
              color: this.getDisabledColor(isDisabled, isSetupScreen),
            }}
            value={inputValue}
            onChange={onChange}
            onBlur={onBlur}
            disabled={isDisabled}
            autoComplete={isEdge ? 'nope' : 'off'}
            placeholder={placeholder}
          />
          {showClearIcon && !isDisabled && !isError ? (
            <FontAwesomeIcon
              icon={faTimesCircle}
              color={'#A5A6A8'}
              style={{ position: 'absolute', right: 20 }}
              onClick={iconClick}
              className="hover-hand"
            />
          ) : null}
        </div>
        <div>
          {helperText ? <p className="helper-text">{helperText}</p> : null}
        </div>
        <div>
          {isError ? (
            <p
              className="error-message"
              style={{ color: isSetupScreen ? '#d0021b' : '#fafbfd' }}
            >
              {this.getErrorMessage(errorMessage)}
            </p>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }

  getErrorMessage(errorMessage) {
    let result = '';
    if (typeof errorMessage === 'string') {
      result = errorMessage;
    }
    return result;
  }

  getBackgroundColor(isSetupScreen, isError, backgroundColorStyles) {
    if(isSetupScreen)
    {
      return 'transparent';
    }
    return isError ? '#432D31': backgroundColorStyles;
  }

  getDisabledColor(isDisabled, isSetupScreen){
    if(isDisabled)
    {
     return '#63666a';
    }
    return isSetupScreen ? '#2F3133': '#fafbfd';
  }
}
